import { render, staticRenderFns } from "./RateConfigDialog.vue?vue&type=template&id=b6a4d590&scoped=true"
import script from "./RateConfigDialog.vue?vue&type=script&lang=js"
export * from "./RateConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./RateConfigDialog.vue?vue&type=style&index=0&id=b6a4d590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a4d590",
  null
  
)

export default component.exports